import {UsersList} from "./UsersList";
// import {UsersEdit} from "./UsersEdit";
// import {UsersCreate} from "./UsersCreate";

export default {
    list: UsersList,
    // create: UsersCreate,
    // edit: UsersEdit
};
